// Need to use the React-specific entry point to import createApi
import { LoginUser, Response } from "Data/interfaces";
import { LoginFormData } from "Pages/Account/Login";
import { ChangePasswordFormData } from "Pages/ChangePassword/ChangePassword";
import { baseApi } from "./baseApi";
import { ProfileFormData } from "Pages/EditProfile/EditProfile";

// Define a service using a base URL and expected endpoints
export const userAuthApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation<Response<LoginUser>, LoginFormData>({
      // Result, Query
      query: (user) => {
        return {
          url: "login",
          method: "POST",
          body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    logout: builder.mutation<Response<object>, void>({
      query: () => {
        return {
          url: "logout",
          method: "POST",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    changePassword: builder.mutation<Response<object>, ChangePasswordFormData>({
      query: (data) => {
        return {
          url: "change-password",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    toggleNotification: builder.mutation<Response<LoginUser>, void>({
      query: () => {
        return {
          url: "toggle-notification",
          method: "POST",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    getProfile: builder.query<Response<LoginUser>, void>({
      query: () => {
        return {
          url: "",
          method: "Get",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
    updateProfile: builder.mutation<
      Response<LoginUser>,
      FormData | ProfileFormData
    >({
      query: (formData) => {
        return {
          url: "",
          method: "PATCH",
          body: formData,
        };
      },
    }),
    deleteProfile: builder.mutation<Response<object>, void>({
      query: () => {
        return {
          url: "",
          method: "DELETE",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLoginUserMutation,
  useLogoutMutation,
  useChangePasswordMutation,
  useToggleNotificationMutation,
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
  useDeleteProfileMutation,
} = userAuthApi;
